<template>
    <div class="prize-wrapper" :style="prizeStyle">

        <img class="prize-img"
            :src="info.$$opts && info.$$opts.prizeSmallImg"
            alt=""
            @click="viewPrize"
            />

        <div class="prize-desc" :style="descStyle">
            {{info.$$opts && info.$$opts.prizeDesc}}
        </div>

        <img class="prize-exchange" :style="exchangeStyle"
            :src="exchangeBtnUrl"
            @click.stop="exchangePrizeTrigger"
            />

    </div>
</template>

<script>
var rem = require('@/utils/rem')
export default {

    name: 'Prize',

    props: {

        index: {
			type: Number,
            required: true,
            default: 0
		},

        info: {
            type: Object,
            required: true,
            default: () => {
                return {}
            }
        },

    },

    inject: ['$$activityId', '$$activityStatus', '$$activityType', 'getEnterSource'],

    computed: {
        enterSource() {
            return this.getEnterSource();
        },
        $activityStatus() {
            return this.$$activityStatus()
        },
    },

    watch: {
        info: {
            handler(val) {
                if (val) {
                    this.initExchangeBtn()
                }

            },
            deep: true
        }

    },

    data() {

        return {

            prizeStyle: {}, // 奖品样式

            descStyle: {}, // 描述样式

            exchangeStyle: {}, // 兑换按钮样式

            exchangeBtnUrl: '', // 兑换按钮地址

        }

    },

    mounted() {

        this.init()

    },

    methods: {

        init() {

            this.initPrizeStyle()

            this.initDescStyle()

            this.initExchangeStyle()

            this.initExchangeBtn()

        },

        handleCss(options = {}) {
            let str= `.a${JSON.stringify(options).replace(/\"/g, '')}`
            let cssStyle  = rem.prototype.generateRem(str).toString()
            cssStyle  = cssStyle .substr(0, cssStyle .length - 1)
            cssStyle  = cssStyle .slice(7)
            return cssStyle.replace(/\,/g, ';')
        },


        initPrizeStyle() { // 初始化奖品样式

            let prize = this.info.prizeConfig && this.info.prizeConfig.prizeDisplay

            let options = {}

            if (prize && prize.position1 && prize.position1.type) {
                options[`${prize.position1.type}`] =  `${prize.position1.value || 0}px`
            }

            if (prize && prize.position2 && prize.position2.type) {
                options[`${prize.position2.type}`] =  `${prize.position2.value || 0}px`
            }


            if (prize && prize.width) {
                options.width = `${prize.width}px`
            }

            if (prize && prize.height) {
                options.height = `${prize.height}px`
            }

            // this.prizeStyle = options
            this.prizeStyle = this.handleCss(options)

        },

        initDescStyle() { // 初始化描述样式
            let desc = this.info && this.info.prizeConfig && this.info.prizeConfig.prizeDesc

            let options = {}

            if (desc && desc.position1 && desc.position1.type) {
                options[`${desc.position1.type}`] =  `${desc.position1.value || 0}px`
            }

            if (desc && desc.position2 && desc.position2.type) {
                options[`${desc.position2.type}`] =  `${desc.position2.value || 0}px`
            }

            options.color      = desc.color
            options.fontSize   = `${desc.fontSize}px`

            options.textStroke = desc.stroke ? `1px ${desc.stroke}` : ''

            options.fontWeight = desc.fontStyle.indexOf('bold') !== -1 ? 'bold' : ''
            options.fontStyle  = desc.fontStyle.indexOf('italic') !== -1 ? 'italic' : ''

            this.descStyle = this.handleCss(options)
            // this.descStyle = options
        },

        initExchangeStyle() { // 初始化兑换按钮样式
            let exchange = this.info && this.info.prizeConfig && this.info.prizeConfig.exchangeBtn

            let options = {}

            if (exchange && exchange.position1 && exchange.position1.type) {
                options[`${exchange.position1.type}`] =  `${exchange.position1.value || 0}px`
            }

            if (exchange && exchange.position2 && exchange.position2.type) {
                options[`${exchange.position2.type}`] =  `${exchange.position2.value || 0}px`
            }


            if (exchange && exchange.width) {
                options.width = `${exchange.width}px`
            }

            if (exchange && exchange.height) {
                options.height = `${exchange.height}px`
            }

            this.exchangeStyle = this.handleCss(options)
            // this.exchangeStyle = options
        },

        initExchangeBtn() { // 初始化兑换按钮地址
            let opts = this.info.$$opts
            let btn =  this.info && this.info.prizeConfig && this.info.prizeConfig.exchangeBtn
            let btnTransfer = {}
            let url = ''
            for (let key in btn) {
                if (btn && btn[key] && btn[key].hasOwnProperty('url')) {
                    btnTransfer[key] = btn[key]['url']
                }
            }

            if (opts && opts.canExchange) {
                url = btnTransfer['exchangeBtn']
            } else {
                let code = opts && opts.notExchangeCode
                let mappingRule = {
                    'ACTIVITY_NOT_START_ERROR': 'activityNotStart',
                    'ACTIVITY_IS_END_ERROR': 'activityFinished',
                    'PRIZE_INVENTORY_ERROR': 'outOfStock',
                    'EXCHANGE_PERSONAL_LIMIT_ERROR': 'prizeExchanged',
                    'EXCHANGE_NOT_START_ERROR': 'exchangeNotStart',
                }
                if (code && mappingRule.hasOwnProperty(code)) {
                    url = btnTransfer[mappingRule[code]]
                } else {
                    url = btnTransfer['exchangeBtn']
                }
            }

            this.exchangeBtnUrl = url

        },

        viewPrize() { // 查看奖品
            this.$emit('emitEvent', {
                type: 'viewPrize',
                data: {
                    index: this.index
                },
                options: null
            })
        },

        exchangePrizeTrigger() { // 兑换奖品触发
            let status = this.$activityStatus
            if (status !== 3) {
                return
            } else {
                let opts = this.info.$$opts
                if (!opts.canExchange) {
                    this.toast(opts.notExchangeReason || '兑换失败')
                } else {
                    this.$log.senLog({
                        pointID: '12010011',
                        eventType: 2,
                        businessData: {
                            activityType: this.$$activityType || '',
                            activityId: this.$$activityId || '',
                            prizeId: this.info.$$opts && this.info.$$opts.prizeId || '',
                            enterSource: this.enterSource || '',
                        }
                    })
                    this.$emit('emitEvent', {
                        type: 'exchangePrizeEvent',
                        data: {
                            index: this.index
                        },
                        options: null
                    })
                }
            }
        },

        toast(txt, duration) { // 封装统一的信息处理函数
            this.$toast({
                styles: {
                    maskColor: "rgba(0,0,0,0)",
                    background: "rgba(0,0,0,0.4)",
                    messageColor: "#fff"
                },
                content: txt,
                duration: duration || 2000
            })
        },
    }


}
</script>

<style lang="scss" scoped>

.prize-wrapper {
    margin: 0;
	padding: 0;
	box-sizing: border-box;
	position: absolute;
    .prize-img {
        margin: 0;
	    padding: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
    .prize-desc {
        margin: 0;
	    padding: 0;
        position: absolute;
        width: 100%;
        text-align: center;
    }
    .prize-exchange {
        margin: 0;
	    padding: 0;
        position: absolute;
    }
}

</style>
